import { ALL_LINES } from "../data/board-geometry";
import type { PlayerColor } from "../types/common";
import type { Board, Row5 } from "../types/game-state";

export function detectRows(board: Board, player: PlayerColor): readonly Row5[] {
  const rows: Row5[] = [];

  for (const line of ALL_LINES) {
    let runStart = -1;
    let runLen = 0;

    for (let i = 0; i <= line.length; i++) {
      const pos = line[i];
      const isMatch =
        pos !== undefined &&
        (board[pos] ?? null)?.type === "MARKER" &&
        (board[pos] as { type: string; player: PlayerColor }).player === player;

      if (isMatch) {
        if (runLen === 0) runStart = i;
        runLen++;
      } else {
        // Emit all valid 5-windows from runStart..runStart+runLen-1
        if (runLen >= 5) {
          for (let w = runStart; w + 4 < runStart + runLen; w++) {
            rows.push({
              positions: [
                line[w],
                line[w + 1],
                line[w + 2],
                line[w + 3],
                line[w + 4],
              ] as [string, string, string, string, string],
              player,
            });
          }
        }
        runStart = -1;
        runLen = 0;
      }
    }
  }

  return rows;
}

export function hasRow(board: Board, player: PlayerColor): boolean {
  return detectRows(board, player).length > 0;
}
